<ng-container *ngIf="(items$ | async)?.length > 1 && (items$ | async) as items">
  <div class="form-group">
    <label>
      <span class="label-content">{{ 'siteContext.' + this.context.toLowerCase() + '.label' | cxTranslate }}</span>
      <select class="form-control" (change)="active = $any($event).target.value">
        <option
          *ngFor="let item of items"
          [attr.aria-label]="item.name"
          value="{{ item.isocode }}"
          [selected]="(activeItem$ | async) === item.isocode"
        >
          {{ item.label }}
        </option>
      </select>
    </label>
  </div>

  <div class="actions">
    <button type="button" class="btn btn-primary btn-sm" (click)="closeModal()">
      {{ 'generic.close' | cxTranslate }}
    </button>
  </div>
</ng-container>
